export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTACT = {
  phone: "(08) 9477 3848",
  phoneHref: "tel:+61894773848",
  text: "0475 776 555",
  textHref: "sms:0475776555",
  email: "team@tpeco.com.au",
  emailHref: "mailto:team@tpeco.com.au",
  smartValve: "https://caromaleaksmart.com.au/",
  logo: "https://customer-assets-agu9un31.emergentagent.net/job_e45c8203-deff-42cb-8e79-29550f78be2f/artifacts/ywt7tlov_LOGO%20WITH%20LICENSE_.png",
  licenses: "PL 8061 · BFL 2246 · EC 17738 · GL 013140",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -110 });
  else el.scrollIntoView({ behavior: "smooth" });
};
